/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface RoleModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class RoleApiService extends SignalAdminResourceApiBase<RoleModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'roles');
  }

  listOptions(params: Record<string, any> = {}): Observable<SignalAdminResourcePage<RoleModel>> {
    return this.client.request<SignalAdminResourcePage<RoleModel>>({
      method: 'GET',
      url: this.resourceUri('roles'),
      params
    });
  }
}
